import { defaultIdQueryFilterKey } from "./types.js";
function constructLinkWithId({ path, id, idQueryFilterKey = defaultIdQueryFilterKey }) {
  const fullUrl = id && id?.length ? `${path}?${idQueryFilterKey}=${id}` : path;
  return fullUrl;
}
export {
  constructLinkWithId
};
//# sourceMappingURL=utils.js.map
